// import store from '@/store'
import { getData } from '@core/utils/http/general'
import store from '@/store'

export default function useSidebarControlEscolar() {
  const accesosDirectos = [

  ]

  return {
    accesosDirectos,
  }
}

export const useSidebar = id => new Promise((resolve, reject) => {
  getData({ action: 5, token: store.state.cuenta.session.token, rolSelected: id }, 'wsadminpagecampus')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
